import { render, staticRenderFns } from "./EditRenderer.vue?vue&type=template&id=84f1b6d6&lang=pug&"
import script from "./EditRenderer.vue?vue&type=script&lang=js&"
export * from "./EditRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports